import { render } from "./CursoPage.vue?vue&type=template&id=2c54d114"
import script from "./CursoPage.vue?vue&type=script&lang=js"
export * from "./CursoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__